import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./Shared/translations/es-ES.json";
import ca from "./Shared/translations/ca-ES.json";
import en from "./Shared/translations/en.json";
import LanguageDetector from 'i18next-browser-languagedetector';


const resources = {
  "es-ES": {
    translations: es,
  },
  "ca-ES": {
    translations: ca,
  },
  "en": {
    translations: en,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    partialBundledLanguages: true,
    ns: ["translations"],
    defaultNS: "translations",
    debug: false,
    fallbackLng: "es-ES",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
  });

export default i18n;
